import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IApiResponse } from 'src/app/interfaces';
import { IRelatorioCabecalhoEmpresaBody } from 'src/app/interfaces/relatorio/EmpresaCabecalhoRelatorio/IRelatorioCabecalhoEmpresaBody';
import { IRelatorioCabecalhoEmpresaResponseData } from 'src/app/interfaces/relatorio/EmpresaCabecalhoRelatorio/IRelatorioCabecalhoEmpresaResponseData';

@Injectable({
  providedIn: 'root'
})
export class ObterEmpresaService {
  private readonly baseURL = '/RelatorioEmpresa';

  constructor(private httpClient: HttpClient) {}
  postRelatorioEmpresa(body: IRelatorioCabecalhoEmpresaBody) {
    return this.httpClient.post<
      IApiResponse<IRelatorioCabecalhoEmpresaResponseData>
    >(this.baseURL, body);
  }
}
